document.querySelectorAll('ul.voice-list li.voice-list-item').forEach(function(item,index){

  item.addEventListener('click', function(event){
    event.preventDefault();
    // console.log(index);

    //すべてのモーダルを閉じる
    document.querySelectorAll('ul.modal-list li div.modal-area').forEach(function(modal){
      modal.style.opacity = '0';
      modal.style.visibility = 'hidden';
      document.documentElement.classList.remove('hidden');
      document.querySelector('.cta-button').style.zIndex = '1';
    });

    //対応するmodal-listのmodal-areaを開く
    const modalItems = document.querySelectorAll('ul.modal-list li.modal-item');
    console.log(modalItems);
    if(modalItems[index]){
      const targetModal = modalItems[index].querySelector('div.modal-area');
      if(targetModal){
        targetModal.style.opacity = '1';
        targetModal.style.visibility = 'visible';
        document.documentElement.classList.add('hidden');
        document.querySelector('.cta-button').style.zIndex = '0';
      }
    }
  })
});

document.querySelectorAll('ul.modal-list li div.modal-area .close').forEach(function(closeBtn){
  closeBtn.addEventListener('click',function(event){
    event.preventDefault();

    const modalArea = closeBtn.closest('div.modal-area');
    if(modalArea){
      modalArea.style.opacity = '0';
      modalArea.style.visibility = 'hidden';
      document.documentElement.classList.remove('hidden');
      document.querySelector('.cta-button').style.zIndex = '1';
    }
  });
});



let mobileSlider;

function initSlider() {
    if (!mobileSlider) {
      mobileSlider = new Swiper('.swiper-voice', {
        //｢前へ｣｢次へ｣の矢印
        navigation: {
        nextEl: '#next',
        prevEl: '#prev',
      },


        //オートプレイ
        autoplay: {
        delay: 2000,
        disableOnInteraction: false
        },
        loop: true,
        spaceBetween: 20, 

        slidesPerView:'auto',
        centeredSlides: true,
        
    });
    }
  }

  function destroySlider() {
    if (mobileSlider) {
      mobileSlider.destroy();
      mobileSlider = null;
    }
  }

  window.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 768) {
      initSlider();
    }
  });

  window.addEventListener('resize', function() {
    if (window.innerWidth <= 768) {
      if (!mobileSlider) {
        console.log('初期化');
        initSlider();
      }
    } else {
      if (mobileSlider) {
        console.log('破棄');
        destroySlider();
      }
    }
  });


const swiper = new Swiper('.menu-list-container.swiper', {

    //オートプレイ
    autoplay: {
        delay: 0,
    },
    loop: true, // ループモードを有効化
    speed:4000,
    slidesPerView: "auto", // 表示するスライド数
    spaceBetween: 20, // スライド間のスペース

    breakpoints: {
      // スライドの表示枚数：500px以上の場合
      320: {
        slidesPerView: 1.5, // 表示するスライド数
      },
      500: {
        slidesPerView: "auto", // 表示するスライド数
      }
    }

});

const swiper2 = new Swiper('.swiper-media', {

    //オートプレイ
    autoplay: {
        delay: 0,
    },
    loop: true, // ループモードを有効化
    speed:3000,
    slidesPerView: "auto", // 表示するスライド数
    spaceBetween: 120, // スライド間のスペース

});



    



